export type PossibleTypesResultData = {
  possibleTypes: {
    RecipeIngredientItem: ["IngredientRecipeIngredient", "SubRecipeRecipeIngredient"];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    RecipeIngredientItem: ["IngredientRecipeIngredient", "SubRecipeRecipeIngredient"],
  },
};
export default result;
